// @format
export enum Parameter {
  CouponCode = 'couponCode',
  URL = 'url',
}
